// extracted by mini-css-extract-plugin
module.exports = {"AcceptInviteForm":"AcceptInviteForm--1VNJt","Extra":"Extra--3mnMw"};